import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { getLearningPathDetails } from "../../../api/endpoints/LearningPathEndpoints";

export default function useGetLearningPathDetails(learningPathId: string) {
  const getLearningPathDetailsFn = useCallback(() => {
    return getLearningPathDetails(learningPathId);
  }, [learningPathId]);

  return useQuery({
    queryKey: ["learning-path", learningPathId],
    queryFn: getLearningPathDetailsFn,
  });
}
